module.exports = __webpack_public_path__ + "assets/0bb2a7660cc4e7db5ad46e141924109e.svg";